import { render, staticRenderFns } from "./PurchaseOrderItem.vue?vue&type=template&id=5df057f8&"
import script from "./PurchaseOrderItem.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports